import { StandardLayout } from "common/layouts/StandardLayout";
import React from "react";
import { Route } from "react-router-dom";
import { PaymentForm } from "../PaymentForm";

export const routes = (
  <Route path="/subscriptions/new">
    <StandardLayout>
      <PaymentForm />
    </StandardLayout>
  </Route>
);
